export default "__VITE_ASSET__BhFHotwK__"